var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-keyword"},[_c('AppInputText',{staticClass:"search-keyword__input",class:{
      'is-error': _vm.isError,
      'is-unset-button': !_vm.useSearchButton
    },attrs:{"placeholder":_vm.placeholder,"maxLength":_vm.maxLength,"value":_vm.text},on:{"inputed":_vm.inputed}}),(_vm.useSearchButton)?_c('button',{staticClass:"search-keyword__button",on:{"click":_vm.clicked}},[_vm._v("検索")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }